export default __webpack_public_path__ + "static/media/otp.e2983ea6.svg";